import ComponentElement from 'components/component-element';
import {createElement, declension, formatMoney, isMobile} from 'methods/utils';
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

function PriceSlider($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.stats = [];

    if (this.options.useCandles) {
        this.$candles        = this.$element.querySelector('.js-candles');
    }

    this.$slider         = this.$element.querySelector('.js-slider');
    this.$priceTextFrom = this.$element.querySelector('.js-price-input-from');
    this.$priceTextTo   = this.$element.querySelector('.js-price-input-to');
    this.$priceInputFrom = this.$element.querySelector('[name="min_price"]');
    this.$priceInputTo   = this.$element.querySelector('[name="max_price"]');

    this.$priceTextFrom.addEventListener('change', this.onPriceInputFromChangeEvent.bind(this));
    this.$priceTextTo.addEventListener('change', this.onPriceInputToChangeEvent.bind(this));

    this.$priceTextFrom.addEventListener('focusin', this.onPriceTextFocusEvent.bind(this));
    this.$priceTextTo.addEventListener('focusin', this.onPriceTextFocusEvent.bind(this));

    this.$priceTextFrom.addEventListener('focusout', this.onPriceTextUnFocusEvent.bind(this));
    this.$priceTextTo.addEventListener('focusout', this.onPriceTextUnFocusEvent.bind(this));

    if (typeof this.options.range.min == 'undefined') {
        this.options.range.min = parseInt(this.$priceTextFrom.value.replace(/\s/g, ''), 10);
    }

    if (typeof this.options.range.max == 'undefined') {
        this.options.range.max = parseInt(this.$priceTextTo.value.replace(/\s/g, ''), 10);
    }

    if (typeof this.options.range.min == 'undefined') {
        throw new Error('range.min is undefined');
    }

    if (typeof this.options.range.min == 'undefined') {
        throw new Error('range.max is undefined');
    }

    this.stats = [
        {value: this.options.range.min, count: 0},
        {value: this.options.range.max, count: 0},
    ];

    this.slider = noUiSlider.create(this.$slider, {
        range: {
            min: 0,
            max: this.stats.length,
        },
        start: [0, this.stats.length],
        step: 1,
        margin: 1,
        connect: true,
    });

    // @see https://refreshless.com/nouislider/events-callbacks/
    this.slider.on('update', this.onUpdateEvent.bind(this));
    this.slider.on('slide', this.onSlideEvent.bind(this));
    this.slider.on('change', this.onChangeEvent.bind(this));

    if (window.pageData && window.pageData.price_slider) {
        this.setStats(window.pageData.price_slider.price_stats);
    }
}

PriceSlider.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(PriceSlider.prototype, 'constructor', {
    value: PriceSlider,
    enumerable: false,
    writable: true,
});

PriceSlider.prototype.setOptions = function(options) {
    ComponentElement.prototype.setOptions.call(this, Object.assign({
        range: {
            min: undefined,
            max: undefined,
        },
    }, options));
}

/**
 * Данные для построения статистики.
 * @param {Array} stats Массив объектов в формате:
 * [
 *     {
 *         value: 100,
 *         count: 100,
 *     },
 * ]
 */
PriceSlider.prototype.setStats = function (stats) {
    const shouldResetBothAfter = !this.isFromOrToValuesSelected();
    const shouldResetFromAfter = !this.isFromValueSelected();
    const shouldResetToAfter   = !this.isToValueSelected();

    this.stats = stats;

    if (this.options.useCandles) {
        this.createCandles();
    }

    this.resetBounds();

    if (shouldResetBothAfter) {
        this.reset();
    } else if (shouldResetFromAfter) {
        this.resetFrom();
    } else if (shouldResetToAfter) {
        this.resetTo();
    }
}

PriceSlider.prototype.createCandles = function () {
    const counts = this.stats.map(stat => stat.count);
    const max    = Math.max(...counts);
    const basicHeight = 10;

    while (this.$candles.lastElementChild) {
        this.$candles.removeChild(this.$candles.lastElementChild);
    }

    this.stats.forEach((stat, index, arr) => {
        const hintContent = declension(stat.count, '%d объект', '%d объекта', '%d объектов').replace('%d', stat.count);
        const height = stat.count ? Math.min(100, basicHeight + Math.ceil(stat.count / max * 100)) : 0;

        const $candle = createElement(
            `<div class="Price-slider__candle" style="height: ${height}%;" data-value="${stat.value}"${!isMobile() ? ` data-hint-content="${hintContent}" data-hint-interactive="false"` : ''}></div>`
        );

        $candle.addEventListener('click', this.onCandleClickEvent.bind(this, $candle, index));

        this.$candles.appendChild($candle);
    });
}

PriceSlider.prototype.activateCandles = function (fromIndex, toIndex) {
    const $candles = [...this.$candles.children];

    $candles.forEach(($candle, index) => {
        $candle.classList.toggle('is-active', index >= fromIndex && index < toIndex);
    });
}

PriceSlider.prototype.reset = function () {
    this.resetFrom();
    this.resetTo();
}

PriceSlider.prototype.resetFrom = function () {
    this.resetSliderFrom();
    this.setPriceInputFromValue(this.getStat(0).value);
}

PriceSlider.prototype.resetTo = function () {
    this.resetSliderTo();
    this.setPriceInputToValue(this.getStat(this.stats.length - 1).value);
}

PriceSlider.prototype.setPriceInputFromValue = function (value) {
    this.$priceInputFrom.value = this.getStat(0).value == value ? '' : value;
    this.$priceTextFrom.value  = this.$priceInputFrom.value ? formatMoney(this.$priceInputFrom.value) : '';
}

PriceSlider.prototype.setPriceInputToValue = function (value) {
    this.$priceInputTo.value = this.getStat(this.stats.length - 1).value == value ? '' : value;
    this.$priceTextTo.value  = this.$priceInputTo.value ? formatMoney(this.$priceInputTo.value) : '';
}

PriceSlider.prototype.resetSliderTo = function () {
    this.setValuesIndex(this.getValuesIndex().from, this.stats.length);
}

PriceSlider.prototype.resetSliderFrom = function () {
    this.setValuesIndex(0, this.getValuesIndex().to);
}

PriceSlider.prototype.getValuesIndex = function () {
    const values = this.slider.get(true /* values as numbers */);

    return {
        from: parseInt(values[0], 10),
        to: parseInt(values[1], 10),
    };
}

PriceSlider.prototype.setValuesIndex = function (from, to) {
    this.slider.set([
        from,
        to,
    ]);
}

PriceSlider.prototype.getStat = function (index) {
    index = Math.max(0, Math.min(this.stats.length - 1, index));
    return this.stats[index];
}

PriceSlider.prototype.setValues = function (from, to) {
    const valueFrom = parseInt(from, 10);
    const valueTo   = parseInt(to, 10);

    const statIndexFrom = this.findClosestValueIndex(from);
    const statIndexTo   = this.findClosestValueIndex(to);

    this.setValuesIndex(
        typeof statIndexFrom == 'undefined' ? 0 : statIndexFrom,
        typeof statIndexTo   == 'undefined' ? this.stats.length : statIndexTo,
    );

    this.setPriceInputFromValue(valueFrom);
    this.setPriceInputToValue(valueTo);

    this.onValuesChanged(from, to);
}

PriceSlider.prototype.getValues = function () {
    let data = {
        from: this.$priceTextFrom.value.replace(/\s/g, ''),
        to: this.$priceTextTo.value.replace(/\s/g, ''),
    };

    data.from = data.from ? parseInt(data.from, 10) : this.getStat(0).value;
    data.to   = data.to ? parseInt(data.to, 10) : this.getStat(this.stats.length - 1).value;

    return data;
}

PriceSlider.prototype.getValueFrom = function () {
    return this.getValues().from;
}

PriceSlider.prototype.getValueTo = function () {
    return this.getValues().to;
}

PriceSlider.prototype.getBounds = function () {
    return {
        min: this.options.range.min,
        max: this.options.range.max,
    };
}

PriceSlider.prototype.resetBounds = function () {
    // последний индекс на 1 больше что-бы можно было выделить последнюю свечу
    this.setBoundsByIndex(0, this.stats.length);
}

PriceSlider.prototype.findValueIndex = function (value) {
    const index = this.stats.findIndex(stat => stat.value == value);
    if (index == -1) {
        return undefined;
    }

    return index;
}

PriceSlider.prototype.findClosestValueIndex = function (value) {
    const exactIndex = this.findValueIndex(value);
    if (typeof exactIndex != 'undefined') {
        return exactIndex;
    }

    const closestIndex = this.stats.findIndex((stat, index, arr) => value >= stat.value && (index == arr.length - 1 || value < arr[index + 1].value));
    if (closestIndex == -1) {
        return undefined;
    }

    return closestIndex;
}

PriceSlider.prototype.setBoundsByIndex = function (min, max) {
    this.options.range.min = parseInt(min, 10);
    this.options.range.max = parseInt(max, 10);

    this.slider.updateOptions({
        range: {
            min: this.options.range.min,
            max: this.options.range.max,
        },
    });
}

PriceSlider.prototype.onCandleClickEvent = function ($candle, index, e) {
    this.setValues(this.getStat(index).value, this.getStat(index + 1).value);
}

PriceSlider.prototype.onSlideEvent = function (values, handle, unencoded, tap, positions, noUiSlider) {
    const indexStatFrom = parseInt(values[0], 10);
    const indexStatTo   = parseInt(values[1], 10);

    const statFrom = this.getStat(indexStatFrom);
    const statTo   = this.getStat(indexStatTo);

    this.setPriceInputFromValue(statFrom.value);
    this.setPriceInputToValue(statTo.value);
}

PriceSlider.prototype.onUpdateEvent = function (values, handle, unencoded, tap, positions, noUiSlider) {
    const indexStatFrom = parseInt(values[0], 10);
    const indexStatTo   = parseInt(values[1], 10);

    const statFrom = this.getStat(indexStatFrom);
    const statTo   = this.getStat(indexStatTo);

    if (this.options.useCandles) {
        this.activateCandles(indexStatFrom, indexStatTo);
    }
}

PriceSlider.prototype.onChangeEvent = function (values, handle, unencoded, tap, positions, noUiSlider) {
    this.onValuesChanged(parseInt(values[0], 10), parseInt(values[1], 10));
}

PriceSlider.prototype.onValuesChanged = function (from, to) {
    this.emit('change', from, to);
}

PriceSlider.prototype.isFromValueSelected = function () {
    return this.getValuesIndex().from != 0;
}

PriceSlider.prototype.isToValueSelected = function () {
    return this.getValuesIndex().to != this.stats.length;
}

PriceSlider.prototype.isFromOrToValuesSelected = function () {
    return this.isFromValueSelected() || this.isToValueSelected();
}

PriceSlider.prototype.onPriceInputFromChangeEvent = function (e) {
    const value = parseInt(this.$priceTextFrom.value, 10);

    if (isNaN(value)) {
        return;
    }

    this.setValues(value, this.getValueTo());
}

PriceSlider.prototype.onPriceInputToChangeEvent = function (e) {
    const value = parseInt(this.$priceTextTo.value, 10);

    if (isNaN(value)) {
        return;
    }

    this.setValues(this.getValueFrom(), value);
}

PriceSlider.prototype.onPriceTextFocusEvent = function (e) {
    e.target.value = e.target.value.replace(/\s/g, '');
}

PriceSlider.prototype.onPriceTextUnFocusEvent = function (e) {
    let value      = e.target.value.replace(/\s/g, '');
    e.target.value = value ? formatMoney(value) : '';
}

PriceSlider.prototype.updatePriceTextPlaceholder = function (min, max) {
    this.$priceTextFrom.setAttribute('placeholder', formatMoney(min));
    this.$priceTextTo.setAttribute('placeholder', formatMoney(max));
}

export default PriceSlider;
